import React from 'react';
import { FlexContainer } from 'components/Containers/FlexContainer/FlexContainer';
import { Button } from 'components/form/Button/Button';
import { Image } from 'components/Image/Image';
import { Row } from 'components/Containers/Row/Row';
import Label from 'components/form/Label/Label';
import { BulletList, Bullet } from 'components/BulletList';
import OText from 'components/CText/OText';

const bullets = [
  'See instantly if you’re pre-qualified',
  'Get funds in as little as one day',
  'Low credit scores accepted',
];
const PersonalLoanLowScoreModuleView = props => {
  return (
    <FlexContainer
      className={
        'flex-container system_neutral_n000 grayShadow16 border-rad8px padT40 padB48 m-padT20 m-padT24'
      }
    >
      <Row className={'format100 mobilePad8'}>
        <FlexContainer className={'flex-column '}>
          <FlexContainer className={'format100 justify-between'}>
            <FlexContainer className={'align-self-center m-hide t-hide'}>
              <Image className={'personalLoanIcon'} />
            </FlexContainer>
            <FlexContainer className={'flex-column'}>
              <FlexContainer>
                <FlexContainer className={'flex-column'}>
                  <Label className="secondary_text_light text-16 bold">
                    {'Have an emergency expense?'}
                  </Label>

                  <Label
                    type="Body-2"
                    className={
                      'text-20 m-text-18 bold margt10 m-margt20 system_neutral_n400_text'
                    }
                  >
                    {'Get it covered with a personal loan'}
                  </Label>
                </FlexContainer>

                <FlexContainer className={'d-hide align-items-start margT6'}>
                  <Button
                    mrphType="primary"
                    onClick={props.onClickPrequal}
                    className="border-rad100px neverFullWidth"
                  >
                    <Label
                      type="Subtitle-2"
                      color="primary_cta_text_light"
                      className={'text-16 m-text-12'}
                      tabIndex="-1"
                    >
                      {'See If I’m Pre-Qualified'}
                    </Label>
                  </Button>
                </FlexContainer>
              </FlexContainer>
              <FlexContainer>
                <BulletList className="m-lineHeight-1-4 margT12 system_neutral_n400_text">
                  {bullets.map((item, index) => {
                    return (
                      <Bullet className="text-14 margT4 block">
                        <OText text={item} />
                      </Bullet>
                    );
                  })}
                </BulletList>
                <FlexContainer
                  className={
                    'justify-between flex-row align-self-center  d-hide'
                  }
                >
                  <Image className={'personalLoanIcon'} />
                </FlexContainer>
              </FlexContainer>
            </FlexContainer>
            <FlexContainer
              className={'align-self-center  flex-row m-hide t-hide'}
            >
              <Button
                mrphType="primary"
                onClick={props.onClickPrequal}
                className="border-rad100px"
              >
                <Label
                  type="Subtitle-2"
                  color="primary_cta_text_light"
                  className={'text-16 m-text-14'}
                  tabIndex="-1"
                >
                  {'See If I’m Pre-Qualified'}
                </Label>
              </Button>
            </FlexContainer>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          className={'flex-column align-items-center margt10 m-margt10 d-hide'}
        ></FlexContainer>
      </Row>
    </FlexContainer>
  );
};

export default PersonalLoanLowScoreModuleView;
